// extracted by mini-css-extract-plugin
module.exports = {"item":"RatingItem_item__9E13E","stat":"RatingItem_stat__g_dP4","link":"RatingItem_link__UqdX8","text":"RatingItem_text__GhdoA"};